import React from 'react';

import StatusInput from '../../internal-components/EditableTitle';
import DeleteDialog from '../../internal-components/GeneralDialog';

import IconButton from '@material-ui/core/IconButton';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import DeleteIcon from '@material-ui/icons/Delete';
import Tooltip from '@material-ui/core/Tooltip';
import Card from '@material-ui/core/Card';
import DragIndicatorIcon from '@material-ui/icons/DragIndicator';
import InputAdornment from '@material-ui/core/InputAdornment';

import styled from 'styled-components/macro';
import CharacterCounter from '../../internal-components/CharacterCounter';
import Animation from '../Animation';

import { Draggable } from 'react-beautiful-dnd';
import useTranslations from '../../hooks/useTranslations';

const Container = styled(Card)`
  padding: 0.8em;
  margin: 0.8em auto 0;
  display: flex;
  border-radius: 8px !important;
  align-items: center;

  svg:not([svgColor]) {
    color: #c8c8c8;
  }
`;

const FormBuilderStatusItemView = props => {
  const t = useTranslations();
  return (
    <>
      <Animation
        in={!props.isInDeleteSequence}
        onExited={props.onDelete}
        type="collapse"
      >
        <Draggable draggableId={props.id} index={props.position}>
          {provided => (
            <Container
              variant="outlined"
              onMouseOver={() => props.setIsCardHovered(true)}
              onMouseOut={() => props.setIsCardHovered(false)}
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              <DragIndicatorIcon
                data-testid={`status-item-${props.name}-${props.id}`}
              />
              <StatusInput
                content={props.name}
                setContent={props.setName}
                onMouseOver={() => props.setIsInputHovered(true)}
                onMouseOut={() => props.setIsInputHovered(false)}
                inputProps={{
                  maxLength: props.nameMaxLength,
                  placeholder: t('statuses.status.placeholder'),
                  onFocus: () => props.setIsInputFocused(true),
                  onBlur: () => props.setIsInputFocused(false)
                }}
                onBlur={props.onNameInputBlur}
                endAdornment={
                  <InputAdornment position="end">
                    <Animation
                      in={props.isInputFocused || props.isInputHovered}
                    >
                      <CharacterCounter
                        string={props.name}
                        maxLength={props.nameMaxLength}
                      />
                    </Animation>
                  </InputAdornment>
                }
              />
              <Tooltip
                arrow
                title={`${
                  !props.isLocked4EndUsers ? 'Lock' : 'Un-lock'
                } submissions for end-users`}
              >
                <IconButton size="small" onClick={props.onToggleLock4EndUsers}>
                  {props.isLocked4EndUsers ? (
                    <LockIcon color="primary" svgColor="primary" />
                  ) : (
                    <LockOpenIcon />
                  )}
                </IconButton>
              </Tooltip>
              <Animation in={props.isCardHovered}>
                <Tooltip arrow title="Delete status">
                  <IconButton
                    size="small"
                    // onClick={() => props.setIsDeleteDialogOpen(true)}
                    onClick={props.onDeleteClicked}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </Animation>
            </Container>
          )}
        </Draggable>
      </Animation>
      <DeleteDialog
        open={props.isDeleteDialogOpen}
        title="delete_form_dialog.title"
        content="statuses.delete.msg"
        variant="delete"
        handleClose={() => props.setIsDeleteDialogOpen(false)}
        handleConfirm={() => {
          props.setIsDeleteDialogOpen(false);
          props.setIsInDeleteSequence(true);
        }}
      />
    </>
  );
};

export default FormBuilderStatusItemView;
